import React, { memo, VFC } from 'react';
import { Icons } from '../constants';
import { KINDS } from '../constants';
import styled from 'styled-components';
import camelCase from 'lodash/camelCase';

const Img = styled.img`
  width: 24px;
`;

interface Props {
  kind: typeof KINDS[keyof typeof KINDS];
}

const Icon: VFC<Props> = memo(({ kind: snakeKind }: Props) => (
  <Img src={Icons[camelCase(snakeKind)]} alt="" />
));

export default Icon;
